import {Injectable} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {InfoSuccessComponent} from '../Components/info-success/info-success.component';
import {InfoProblemComponent} from '../Components/info-problem/info-problem.component';

@Injectable({
  providedIn: 'root'
})
export class InfoStatusService {

  constructor(private modalService: NgbModal) { }

  openSuccessModal(contenu:string):void{
    const modalRef = this.modalService.open(InfoSuccessComponent,{size:'sm'});
    modalRef.componentInstance.contenu = contenu;
    modalRef.result.then((result)=>{

    });
  }

  openWarningModal(contenu:string):void{
    const modalRef = this.modalService.open(InfoProblemComponent,{size:'sm'});
    modalRef.componentInstance.contenu = contenu;
    modalRef.result.then((result)=>{

    });
  }
}
